import { useCallback, type ElementRef } from "react";

/**
 * Hook that scrolls to the top of the page when the component ref mounts.
 *
 * @param callback - A callback that will be called after the scroll. Ensure to provide a stable reference (memoized) to the callback.
 * @returns An object with the scroller function.
 */

export function useScrollToPageTopOnMount(
  callback?: (element: HTMLDivElement) => void,
) {
  const scroller = useCallback(
    (ref: ElementRef<"div"> | null) => {
      if (!ref) return;

      if (window.scrollY > 0) {
        window.scrollTo({ top: 0 });

        if (callback) {
          callback(ref);
        }
      }
    },
    [callback],
  );

  return { scroller };
}
